import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { SOCKET_PROTOCOL, PAUL_DOMAIN } from 'constants';
import { io } from 'socket.io-client';
import { Loader } from 'components/ui';
import { v4 as uuidv4 } from 'uuid';
const SocketContext = createContext({});
import igLogger from 'services/logger';

export const useSocket = () => useContext(SocketContext);

const generateUniqueSessionId = () => {
  const tabId = sessionStorage.getItem('tabId') || uuidv4();
  sessionStorage.setItem('tabId', tabId);
  return tabId;
};

const SocketProvider = ({ children, requestId, useLoader = false }) => {
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  const [loading, setLoading] = useState(useLoader);
  const connectSocket = (uniqueSessionId) => {
    socketRef.current = null;
    setSocket(null);
    if (useLoader) {
      setLoading(true);
    }
    const socketIo = io(`${SOCKET_PROTOCOL}://${PAUL_DOMAIN}`, {
      query: {
        request_id: requestId,
        uniqueSessionId: uniqueSessionId,
      },
      randomizationFactor: 0.5,
    });

    socketIo.on('connect', () => {
      igLogger.log('SOCKET', `connected in ${socketIo?.io?.engine?.transport?.name}`);
      if (useLoader) {
        setLoading(false);
      }
    });

    socketIo.io.engine.on('upgrading', (transport) => {
      igLogger.log('SOCKET', `upgrading to ${transport.name}`);
    });

    socketIo.io.engine.on('upgrade', (transport) => {
      igLogger.log('SOCKET', `upgraded to ${transport.name}`);
    });

    socketIo.on('reconnect_failed', () => {
      igLogger.log('SOCKET', 'reconnection failed after 5 attempts');
    });

    socketIo.on('reconnect_attempt', (attempt) => {
      igLogger.log('SOCKET', `reconnection attempt ${attempt}/5`);
    });
    socketRef.current = socketIo;
    setSocket(socketIo);
  };

  const disconnectSocket = () => {
    if (socketRef.current) {
      socketRef.current.disconnect();
      socketRef.current = null;
      setSocket(null);
    }
  };

  useEffect(() => {
    const uniqueSessionId = generateUniqueSessionId();
    connectSocket(uniqueSessionId);
    return () => {
      disconnectSocket();
    };
  }, []);

  window.logSocketHere = () => {
    socketRef.current.onAny((event, data) => {
      console.log(`%c${event}`, 'background: lightgreen; padding: 2px 5px', data);
    });
    socketRef.current.onAnyOutgoing((event, data) => {
      console.log(`%c${event}`, 'background: lightblue; padding: 2px 5px', data);
    });
  };

  if (loading || !socket) {
    return <Loader />;
  }

  return (
    <SocketContext.Provider
      value={{
        socket,
        disconnectSocket,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProvider;
